import { DataSourceExecutionEvent } from "@mcleod/components";
import { LayoutUrl } from "@mcleod/core";
import { AutogenLayoutContactQuickInfo } from "./autogen/AutogenLayoutContactQuickInfo";

const parentLayouts = {
    "C": "lme/ar/Customer",
    "5": "lme/general/Driver",
    "L": "lme/dispatch/Location",
    "F": "lme/settlement/FactoringCompany",
    "P": "lme/dispatch/Payee"
};

export class ContactQuickInfo extends AutogenLayoutContactQuickInfo {

    sourceContactAfterExecution(event: DataSourceExecutionEvent) {
        const parentType = event.data?.get("parent_row_type");
        this.textboxName.printableLabel.link =  LayoutUrl.create(parentLayouts[parentType], {
            mode: "update",
            key: event.data?.get("parent_row_id"),
            contact: event.data?.get("id")
        });
    }
}
